import { privateApiGet } from 'functions/privateApi'

export default async function getUserProfile (){
    const endpoint = '/app/v1/user-info'
    return await privateApiGet(endpoint)
}